import { ModuleModel } from '../../module.model.interface';

export enum DashboardItemType {
  Report,
  Chart,
  Kpi
}

export enum DashboardItemFilterType {
  Organization,
  Generic,
  DateInterval
}

export class DashboardItemFilter {
  public field: string;
  public title: string;
  public type: DashboardItemFilterType;
  public items?: string[];
  public value?: any;
  public textValue?: string;

  constructor(options? : {
    field: string;
    title: string;
    type: DashboardItemFilterType;
    items?: string[];
    value?: any;
    textValue?: string;
  }) {
    this.field = options.field;
    this.title = options.title;
    this.type = options.type;
    this.items = options.items;
    this.value = options.value;
    this.textValue = options.textValue;
  }
}

export class DashboardItemColumn {
  public field: string;
  public title: string;
  public tooltip?: string;
  
  constructor(options? : {
    field: string;
    title: string;
    tooltip?: string;
  }) {
    this.field = options.field;
    this.title = options.title;
    this.tooltip = options.tooltip;
  }
}

export class DashboardItemDescriptor implements ModuleModel {
  public discriminator = 'DashboardItemDescriptor';

  public id: string;
  public title: string;
  public type: DashboardItemType;
  public filters: DashboardItemFilter[];
  public columns: DashboardItemColumn[];
  public json?: any;
  public data?: any;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;

    title: string;
    type: DashboardItemType;
    filters: DashboardItemFilter[];
    columns: DashboardItemColumn[];
    json?: any;
    data?: any;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;

      this.title = options.title;
      this.type = options.type;
      this.filters = options.filters;
      this.columns = options.columns;
      this.json = options.json;
      this.data = options.data;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/model/dashboard.item.ts